var I={PRIMARY:"PRIMARY",NEGATIVE:"NEGATIVE",POSITIVE:"POSITIVE"};export{I as DROPDOWN_CHIP_COLORS};
